export default __webpack_public_path__ + "pr_light.365b2c4a.svg";